var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBridgeOverRiver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32745_17392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.625 23.0896C1.625 23.0896 11.2083 20.5896 20.375 20.5896C29.5417 20.5896 39.125 23.0896 39.125 23.0896",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 18.0896C1.625 18.0896 11.2083 15.5896 20.375 15.5896C29.5417 15.5896 39.125 18.0896 39.125 18.0896",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0415 22.2563V15.5896",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.375 20.5895L20.375 13.9229",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7085 22.2563V15.5896",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7085 27.2561L28.7085 22.2561L33.7085 22.7824V27.2561",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7085 27.2561V22.2561L8.7085 22.7824V27.2561",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 38.4896C2.84227 38.4896 4.04244 38.3177 5.12828 37.9876C6.21413 37.6575 7.15511 37.1785 7.875 36.5896C8.59481 37.1786 9.53576 37.6576 10.6216 37.9878C11.7075 38.318 12.9077 38.4901 14.125 38.4901C15.3423 38.4901 16.5425 38.318 17.6284 37.9878C18.7142 37.6576 19.6552 37.1786 20.375 36.5896C21.0948 37.1786 22.0358 37.6576 23.1216 37.9878C24.2075 38.318 25.4077 38.4901 26.625 38.4901C27.8423 38.4901 29.0425 38.318 30.1284 37.9878C31.2142 37.6576 32.1552 37.1786 32.875 36.5896C33.5949 37.1785 34.5359 37.6575 35.6217 37.9876C36.7076 38.3177 37.9077 38.4896 39.125 38.4896",
    stroke: "#101820",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32745_17392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.375 0.5896)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeOverRiver);
export default __webpack_public_path__ + "static/media/bridgeOverRiver.bb476234ec097b7202bd320f32ae1834.svg";
export { ForwardRef as ReactComponent };